import * as React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps, Color } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export type SnackBarCloseHandler = () => any;

export enum SnackBarType {
    Information = 0,
    Success = 1,
    Error = 2,
    Warning = 3,
}

export interface SnackBarProps {
  message: string;
  type: SnackBarType;
  open: boolean;
  onCloseHandler: SnackBarCloseHandler,
}

const SnackBar = (props: SnackBarProps) => {
  const { message, type, open, onCloseHandler } = props;
  const checkOutState = React.useContext(CheckOutStateContext);
  const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
      primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    onCloseHandler();
  };

  const getSeverity = (): Color => {
      if (type === SnackBarType.Information) {
        return 'info';
      }
      else if (type === SnackBarType.Success) {
        return 'success';
      }
      else if (type === SnackBarType.Error) {
        return 'error';
      }
      else {
        return 'warning';
      }
  }

  return (
    <div className={classes.root}>
      <Snackbar 
        open={open} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={8000} 
        onClose={handleClose}>
        <Alert onClose={handleClose} severity={getSeverity()}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default SnackBar;